module.exports = __webpack_public_path__ + "static/media/map-nav-bar-expand-icon.39e71636.svg";